'use strict'

export default () => {
  return window.MD && window.MD.API_URL
    ? window.MD.API_URL
    : 'https://dev-api.markitdigital.com/'
}
